import React from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

const WIDTHS = ['xs', 'sm', 'md', 'lg', 'xl']

const widthIndex = width => WIDTHS.indexOf(width)

export const isWidthUp = (breakpoint, width, inclusive = true) => {
  const breakpointIndex = widthIndex(breakpoint)
  const widthValueIndex = widthIndex(width)
  if (inclusive) return widthValueIndex >= breakpointIndex
  return widthValueIndex > breakpointIndex
}

export const isWidthDown = (breakpoint, width, inclusive = true) => {
  const breakpointIndex = widthIndex(breakpoint)
  const widthValueIndex = widthIndex(width)
  if (inclusive) return widthValueIndex <= breakpointIndex
  return widthValueIndex < breakpointIndex
}

const withWidth = () => WrappedComponent => {
  const WithWidth = props => {
    const theme = useTheme()
    const isXlUp = useMediaQuery(theme.breakpoints.up('xl'))
    const isLgUp = useMediaQuery(theme.breakpoints.up('lg'))
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'))
    const isSmUp = useMediaQuery(theme.breakpoints.up('sm'))

    let width = 'xs'
    if (isXlUp) width = 'xl'
    else if (isLgUp) width = 'lg'
    else if (isMdUp) width = 'md'
    else if (isSmUp) width = 'sm'

    return <WrappedComponent {...props} width={width} />
  }

  return WithWidth
}

export default withWidth
